// extracted by mini-css-extract-plugin
module.exports = {"card":"PasswordChangeFail_card__2oM8X"};